export default __webpack_public_path__ + "static/media/diners.3ff1a7fb.svg";